module.exports = __webpack_public_path__ + "img/ASE-EagleSUN-TM-WithTagLine.69de1ef7.png";